export const PRODUCT_NAMES: { [id: string]: string } = {
  freemium: 'Free',
  'premium-basic': 'Basic',
  'premium-advanced': 'Basic Plus',
}

export const B2B_INDIVIDUAL_PRODUCT = 'b2b-individual'
